import React, {FC} from "react";
import {observer} from "mobx-react";
import styled from "@emotion/styled";
import {NavLink} from "react-router-dom";
import {MOBILE_HEADER_HEIGHT} from "data/constants/header";
import {MENU_LINKS} from "data/constants/navigation";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {ILocalizationController} from "views/controllers/localization/localization.controller";
import {Exist} from "views/components/exist/exist.component";
import {PureButton} from "views/components/style";
import {media} from "assets/css/media";

const Wrapper = styled.nav`
	position: absolute;
	width: 100%;
	height: calc(100vh - ${MOBILE_HEADER_HEIGHT}px);
	background: #12156f;
	top: ${MOBILE_HEADER_HEIGHT}px;
	box-shadow: 0 0 10px #85888c;
	-webkit-font-smoothing: antialiased;
	transform-origin: 0% 0%;
	transform: translate(-100%, 0);
	transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1);

	&.open {
		transform: none;
	}

	@media (min-width: ${media.tablet}) {
		display: none;
	}
`;

const css = `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 100%;
  background: #1d22a9;
  color: #ffffff;
  border-bottom: 1px solid rgb(18, 21, 111);
  font-size: 16px;

  &.active,
  &:hover {
	background: #292fc7;
  }
`;

const Link = styled(NavLink)`
	${css};
	gap: 4px;

	* {
		transition: all 0.3s;

		path {
			fill: #ffffff;
		}
	}
`;

const Button = styled(PureButton)`
	${css}
`;

interface IMobileNav {
	isOpen: boolean;
	closeMenu: () => void;
	isAuthorized: boolean;
	SSOLoginHandler: () => void;
}

export const MobileNav: FC<IMobileNav> = observer(
	({isOpen, closeMenu, isAuthorized, SSOLoginHandler}) => {
		const {i18n} = useViewController<ILocalizationController>(Bindings.LocalizationController);
		const className = isOpen ? "open" : "";

		return (
			<Wrapper className={className}>
				<ul>
					<li>
						<Exist when={isAuthorized}>
							<Link to="/account" onClick={closeMenu}>
								{i18n.t("header.nav.account")}
							</Link>
						</Exist>

						<Exist when={!isAuthorized}>
							<Button onClick={SSOLoginHandler}>{i18n.t("header.nav.login")}</Button>
						</Exist>
					</li>

					{MENU_LINKS.map(({Icon, url, name}, index) => (
						<li key={index}>
							<Link to={url} onClick={closeMenu}>
								{i18n.t(name)}

								{Icon && <Icon />}
							</Link>
						</li>
					))}
				</ul>
			</Wrapper>
		);
	}
);
